import React from 'react'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'

const DateInput = ({
    value = new Date(),
    onChange = () => {}
}) => {
    const [pickerVisible, setVisible] = React.useState(false)

    const onDateChange = (momentDate) => {
        onChange(momentDate.toDate())
    }

    return (
        <SingleDatePicker
            date={moment(value)}
            onDateChange={date => onDateChange(date)}
            focused={pickerVisible}
            onFocusChange={({ focused }) => setVisible(focused)}
            numberOfMonths={1}
            hideKeyboardShortcutsPanel
            regular
            isOutsideRange={() => false}
        />
    )
}

export default DateInput